import { render } from "./index.vue?vue&type=template&id=74e933be"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/BaseExtendFields/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74e933be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74e933be', __exports__)) {
    api.reload('74e933be', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=74e933be", () => {
    api.rerender('74e933be', render)
  })

}


export default __exports__